<template>
  <div class="activity-score-entry-top-bar">
    <!-- 操作栏容器 -->
    <div class="practicalActivity-info-operation-container">
      <div class="practicalActivity-info-search-container">
        <el-button @click="$router.back()" size="small">返回</el-button>
        <div class="activity-name">活动名称：{{ activityData.activityName }}</div>
      </div>
      <div class="practicalActivity-info-button-container">
        <!-- 搜索框 -->
        <search class="search" :placeholder="'请输入学生名称'" @search="studentNameSearch" />
        <!-- 年级 -->
        <div class="select">
          <el-select v-model="gradeId" placeholder="选择年级" @change="gradeChange" clearable>
            <el-option :label="item.gradeName" :value="item.gradeId" v-for="(item, index) in classSelectList"
              :key="index"></el-option>
          </el-select>
        </div>
        <!-- 班级 -->
        <div class="select">
          <el-select v-model="classId" placeholder="选择班级" @change="classChange" clearable>
            <div slot="empty" style="
                padding: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #c0c4cc;
              ">
              <div>未选择年级</div>
            </div>
            <el-option :label="item.className" :value="item.classId" v-for="(item, index) in classList" :key="index">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" round size="medium" @click="scoreEntryClick"
          v-hasPermi="'sc:practicerecord:add'">录入成绩</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
export default {
  props: ["activityData", "classSelectList"],
  components: {
    search,
  },
  data() {
    return {
      gradeId: "",
      classId: "",
      classList: []
    };
  },
  methods: {
    gradeChange(e) {
      if (e == "") {
        this.classList = [];
      } else {
        this.classList = this.classSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      }
      this.classId = "";
      this.gradeId = e;

      this.$emit("gradeChange", e);
    },
    classChange(e) {
      this.classId = e;
      this.$emit("classChange", e);
    },
    studentNameSearch(e) {
      this.$emit("studentNameSearch", e);
    },
    scoreEntryClick() {
      this.$emit("scoreEntryClick", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./activityScoreEntryTopBar.scss";
</style>